let app = { layout: 'default', middleware: 'auth' }
let signUp = { layout: '', middleware: 'auth' }
let onboarding = { layout: '', middleware: 'auth' }

export default [
	{
		name: 'sign-up/step-1',
		path: '/signup/company',
		component: () => import('~/pages/sign-up/1-company.vue'),
		meta: signUp,
	},
	{
		name: 'sign-up/step-2',
		path: '/signup/product',
		component: () => import('~/pages/sign-up/2-location.vue'),
		meta: signUp,
	},
	{
		name: 'sign-up/step-3',
		path: '/signup/plan',
		component: () => import('~/pages/sign-up/3-plan.vue'),
		meta: signUp,
	},
	{
		name: 'sign-up/step-4',
		path: '/signup/payment',
		component: () => import('~/pages/sign-up/4-payment.vue'),
		meta: signUp,
	},
	{
		name: 'sign-up/step-5',
		path: '/signup/complete',
		component: () => import('~/pages/sign-up/5-complete.vue'),
		meta: signUp,
	},

	{
		name: 'onboarding/step-1',
		path: '/onboarding/business',
		component: () => import('~/pages/onboarding/1-business.vue'),
		meta: onboarding,
	},
	{
		name: 'onboarding/step-2',
		path: '/onboarding/images',
		component: () => import('~/pages/onboarding/2-images.vue'),
		meta: onboarding,
	},
	{
		name: 'onboarding/step-3',
		path: '/onboarding/verification',
		component: () => import('~/pages/onboarding/3-verification.vue'),
		meta: onboarding,
	},
	{
		name: 'onboarding/step-4',
		path: '/onboarding/landing-page',
		component: () => import('~/pages/onboarding/4-build.vue'),
		meta: onboarding,
	},
	{
		name: 'onboarding/step-5',
		path: '/onboarding/launch',
		component: () => import('~/pages/onboarding/5-launch.vue'),
		meta: onboarding,
	},

	{
		name: 'leads',
		path: '/leads',
		component: () => import('~/pages/customer/leads.vue'),
		meta: app,
	},

	{
		name: 'contacts',
		path: '/prospects',
		component: () => import('~/pages/customer/contact/contacts.vue'),
		meta: app,
	},

	{
		name: 'contact',
		path: '/prospects/:id',
		component: () => import('~/pages/customer/contact/contact.vue'),
		meta: app,
		props: true,
	},

	{
		name: 'deals',
		path: '/deals/:view',
		component: () => import('~/pages/customer/deal/deals.vue'),
		meta: app,
		props: true,
	},
	{
		name: 'deal',
		path: '/deal/:id',
		component: () => import('~/pages/customer/deal/deal.vue'),
		meta: app,
		props: true,
	},

	{
		name: 'tasks',
		path: '/tasks',
		component: () => import('~/pages/customer/tasks.vue'),
		meta: app,
	},

	{
		name: 'events',
		path: '/events',
		component: () => import('~/pages/customer/events.vue'),
		meta: app,
	},

	{
		name: 'calendar',
		path: '/calendar',
		component: () => import('~/pages/customer/calendar.vue'),
		meta: app,
	},

	{
		name: 'reporting-leads',
		path: '/reporting/leads',
		component: () => import('~/pages/customer/reporting/leads.vue'),
		meta: app,
	},

	{
		name: 'reporting-deals',
		path: '/reporting/deals',
		component: () => import('~/pages/customer/reporting/deals.vue'),
		meta: app,
	},

	{
		name: 'notifications',
		path: '/notifications',
		component: () => import('~/pages/customer/notifications.vue'),
		meta: app,
	},

	{
		name: 'settings-subscriptions',
		path: '/settings/subscriptions',
		component: () => import('~/pages/customer/settings/subscriptions.vue'),
		meta: app,
	},

	{
		name: 'settings-subscription',
		path: '/settings/subscription/:id',
		component: () => import('~/pages/customer/settings/subscription.vue'),
		meta: { ...app, subMenu: true },
		props: true,
	},

	{
		name: 'crm-usage-settings',
		path: '/settings/subscription/:id/call-assistant',
		component: () => import('~/pages/customer/settings/crm-usage-settings.vue'),
		meta: { ...app, subMenu: true },
		props: true,
	},

	{
		name: 'crm-usage',
		path: '/settings/subscription/:id/usage',
		component: () => import('~/pages/customer/settings/crm-usage.vue'),
		meta: { ...app, subMenu: true },
		props: true,
	},

	{
		name: 'settings-invoices',
		path: '/settings/invoices',
		component: () => import('~/pages/customer/settings/invoices.vue'),
		meta: app,
	},

	{
		name: 'settings-payment-methods',
		path: '/settings/payment-methods',
		component: () => import('~/pages/customer/settings/payment-methods.vue'),
		meta: app,
	},

	{
		name: 'settings-users',
		path: '/settings/users/:id',
		component: () => import('~/pages/customer/settings/users.vue'),
		meta: { ...app, subMenu: true },
		props: true,
	},

	{
		name: 'settings-pipeline-stages',
		path: '/settings/configuration/:id',
		component: () => import('~/pages/customer/settings/configuration.vue'),
		meta: { ...app, subMenu: true },
		props: true,
	},

	{
		path: '/settings/configuration/:id/:view',
		component: () => import('~/pages/customer/settings/configuration.vue'),
		meta: { ...app, subMenu: true },
		props: true,
	},

	{
		path: '/settings/profile',
		component: () => import('~/pages/customer/settings/profile.vue'),
		meta: { ...app, subMenu: false },
	},

	{
		path: '/settings/notifications/:id',
		component: () => import('~/pages/customer/settings/notifications.vue'),
		meta: { ...app, subMenu: true, },
		props: true
	},

	// {
	// 	name: 'settings-pipeline-stages',
	// 	path: '/settings/subscription/:id/pipeline-stages',
	// 	component: () => import('~/pages/customer/settings/pipeline-stages.vue'),
	// 	meta: { ...app, subMenu: true },
	// 	props: true,
	// },

	// {
	// 	name: 'settings-default-folders',
	// 	path: '/settings/subscription/:id/default-folders',
	// 	component: () => import('~/pages/customer/settings/default-folders.vue'),
	// 	meta: { ...app, subMenu: true },
	// 	props: true,
	// },

	// {
	// 	name: 'settings-lead-sources',
	// 	path: '/settings/subscription/:id/lead-sources',
	// 	component: () => import('~/pages/customer/settings/lead-sources.vue'),
	// 	meta: { ...app, subMenu: true },
	// 	props: true,
	// },

	{
		name: 'calls',
		path: '/calls',
		component: () => import('~/pages/customer/calls.vue'),
		meta: app,
	},

	{
		name: 'inbox',
		path: '/inbox',
		component: () => import('~/pages/customer/inbox.vue'),
		meta: app,
	},
]
